
<template>
    <zj-layout-container
      v-loading="isEventInfoLoading || loading"
      :element-loading-text="loadingText">
      <zj-layout-header>
        <EventTimeLine :timeIndex="status"></EventTimeLine>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <EventInfo
            :EventConfirm="EventConfirm"
            :EventInfoEdit="EventInfoEdit"
            :EventSourceEdit="EventSourceEdit"
            :EventAffectEdit="EventAffectEdit"
            :EventConfirmEdit="EventConfirmEdit"
            :editable="editable"
            :EventReport="EventReport"
            :IsOnlyView="true"
            :activeNames="activeNames"
            :IsNoLoading="true"
            @showLoading="onEventInfoShowLoading"
            @hideLoading="onEventInfoHideLoading"
          >
            <template name="default">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="16rem"
                class="finisheventform"
              >
                <el-collapse v-model="activeNames" style="margin-top: 2px;">
                  <el-collapse-item name="EmergencyCommand">
                    <template slot="title">
                      <i class="header-icon el-icon-arrow-down"></i>
                      <span class="spantitle">应急指挥：</span>
                    </template>
                    <el-form-item label="接报核实耗时" style="display:inline-block;">
                      <el-input v-model="Re_veTakeTime" disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="态势分析耗时" prop="EventName" style="display:inline-block;">
                      <el-input v-model="SituationAnalysisTime" disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="应急处置耗时" prop="EventName" style="display:inline-block;">
                      <el-input v-model="EmergencyResponseTime" disabled="true"></el-input>
                    </el-form-item>

                    <el-form-item label="任务派发量" style="display:inline-block;">
                      <el-input v-model="TaskVolume" disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="异常任务数量" prop="EventName" style="display:inline-block;">
                      <el-input v-model="UnusualTaskVolume" disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="任务完成数量" prop="EventName" style="display:inline-block;">
                      <el-input v-model="CompleteTaskVolume" disabled="true"></el-input>
                    </el-form-item>

                    <el-form-item label="调动应急人员" style="display:inline-block;">
                      <el-input v-model="RescueVolume" disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="调动应急物资" prop="EventName" style="display:inline-block;">
                      <el-input v-model="MeterialVolume" disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="调动应急车辆" prop="EventName" style="display:inline-block;">
                      <el-input v-model="TransportVolume" disabled="true"></el-input>
                    </el-form-item>

                    <el-form-item label="应急处置成本估算" prop="EventName" style="display:inline-block;">
                      <el-input type="textarea" rows="3" v-model="ruleForm.CostEstimation"></el-input>
                    </el-form-item>
                  </el-collapse-item>
                  <el-collapse-item name="EventSummary" class="EventSummary">
                    <template slot="title">
                      <i class="header-icon el-icon-arrow-down"></i>
                      <span class="spantitle">事件总结</span>
                    </template>
                    <el-form-item label="事件总结">
                      <el-input type="textarea" rows="5" v-model="ruleForm.EventSummary" show-word-limit maxlength="500"></el-input>
                    </el-form-item>

                    <el-form-item label="善后负责人" prop="AfterChargerId">
                      <el-select v-model="ruleForm.AfterChargerId">
                        <el-option-group
                          v-for="group in UsersOptions"
                          :key="group.label"
                          :label="group.label"
                        >
                          <el-option
                            v-for="item in group.options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-option-group>
                      </el-select>
                    </el-form-item>

                    <el-form-item
                      label="善后参与人"
                      prop="AfterparticipaterIds"
                      class="AfterparticipaterUsers"
                    >
                      <el-select
                        multiple multiple-limit="10"
                        v-model="ruleForm.AfterparticipaterIds">
                        <el-option-group
                          v-for="group in UsersOptions"
                          :key="group.label"
                          :label="group.label"
                        >
                          <el-option
                            v-for="item in group.options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-option-group>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="善后处理意见">
                      <el-input type="textarea" rows="5" v-model="ruleForm.DealSuggestion"></el-input>
                    </el-form-item>
                  </el-collapse-item>
                </el-collapse>
              </el-form>
            </template>
          </EventInfo>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <div style="text-align:center;">
          <el-button @click="onBack()">返回</el-button>
          <el-button type="primary" @click="ConfirmSummary()">确认</el-button>
        </div>
      </zj-layout-footer>
    </zj-layout-container>
</template>
<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
import EventTimeLine from "./EventTimeLine.vue";
import EventInfo from "./EventInfo.vue";
const utils = ZJApp.ZJUtils;
export default {
  name: "ZjFinishEvent",
  controller: "UI",
  action: "FinishEvent",
  components: {
    EventTimeLine,
    EventInfo
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中',
      isEventInfoLoading: false,
      UsersOptions: [],
      ChildUser: [],
      status: parseInt(this.$route.query.Status),
      EventInfoEdit: true,
      EventSourceEdit: true,
      EventAffectEdit: true,
      EventConfirmEdit: true,
      editable: false,
      EventReport: this.$route.query.IsReport == null,
      activeNames: ["EmergencyCommand", "EventSummary"],
      Re_veTakeTime: "",
      SituationAnalysisTime: "",
      EmergencyResponseTime: "",
      TaskVolume: "",
      UnusualTaskVolume: "",
      CompleteTaskVolume: "",
      RescueVolume: "",
      MeterialVolume: "",
      TransportVolume: "",
      ruleForm: {
        OrgId: "",
        CostEstimation: "",
        AfterChargerId: "",
        AfterparticipaterIds: "",
        ExecutId: "", //执行记录Id
        EventId: "" //应急事件Id
      }
    };
  },
  created: function() {
    
    this.ruleForm.ExecutId = this.$route.query.ExecutId;
    this.ruleForm.EventId = this.$route.query.EventId;
    this.ruleForm.OrgId = this.user.Departments[0].OrgId;

    let obj = {
      EventId: this.$route.query.EventId,
      PageSize: 20,
      PageIndex: 1,
      TotalCount: 0,
      StartNumber: 0,
      EndNumber: 0
    };

    this.showLoading('加载中...');
    utils.waitAll([
      this.config.getUValue("EmergencyService:PersonOrgianiztionType:", ""),
      new MyApis.AddressbookApi().FindByConditions({}),
      new MyApis.EmergencyEventApi().GetEventSummaryStatistical(obj)
    ])
    .then(r=>{

      this.GetUserData(r[0].JValue, r[1].data.Data);

      const stat = r[2].data.Data;
      //console.log(r);
      this.Re_veTakeTime = stat.Re_veTakeTime;
      this.SituationAnalysisTime = stat.SituationAnalysisTime;
      this.EmergencyResponseTime = stat.EmergencyResponseTime;
      this.TaskVolume = stat.TaskVolume;
      this.UnusualTaskVolume = stat.UnusualTaskVolume;
      this.CompleteTaskVolume = stat.CompleteTaskVolume;
      this.RescueVolume = stat.RescueVolume;
      this.MeterialVolume = stat.MeterialVolume;
      this.TransportVolume = stat.TransportVolume;

      this.hideLoading();
    })
    .catch(e=>{
      console.error(e);
      this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
      this.hideLoading();
    });
    
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    showLoading(text) {
      this.loading = true;
      this.loadingText = text || '';
    },
    hideLoading() {
      this.loading = false;
    },
    onEventInfoShowLoading(e) {
      this.isEventInfoLoading = true;
      this.loadingText = e.text;
    },
    onEventInfoHideLoading() {
      this.isEventInfoLoading = false;
    },
    GetUserData(Fatoption, Chiloption) {
      this.ChildUser = Chiloption;
      var userOpt = [];
      for (var i = 0; i < Fatoption.length; i++) {
        var item = Fatoption[i];
        var users = [];
        for (var j = 0; j < Chiloption.length; j++) {
          var user = Chiloption[j];
          if (user.ResourceTypeId == item.ItemKey) {
            users.push({ value: user.BookId, label: user.PersonName });
          }
        }
        userOpt.push({
          label: item.Extend1,
          options: users
        });
      }
      this.UsersOptions = userOpt;
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //确认
    ConfirmSummary() {
      //this.user.Departments[0].OrgId;
      // 保存总结信息
      let AfterparticipaterIdsArr = this.ruleForm.AfterparticipaterIds;
      let data = utils.extend({}, this.ruleForm, {
        AfterparticipaterIds: (AfterparticipaterIdsArr || []).join(";")
      });
      this.showLoading('保存中...');
      new MyApis.ExecutSummaryApi()
        .AddItem(data)
        .then(r => {
          if (r && r.data && r.data.Data) {
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.logInfo.ActionName = "应急事件总结";
            this.logInfo.LogMessage = r ? "应急事件总结保存成功" : "应急事件总结保存失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "应急事件总结信息";
            this.addOperationLog();
            //跳转到待归档列表
            this.$router.push({
              path: "/plugin/emergency/ui/EventList",
              // name: 'mallList',
              query: { Status: 6 }
            });
          }
          else {
            this.errmsg("服务异常，请联系管理员！");
          }
          this.hideLoading();
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.hideLoading();
        });
    }
  }
};
</script>
<style lang="scss">
.finisheventform .el-input {
  width: 20rem;
}
.finisheventform .el-textarea {
  width: 96rem;
}
.finisheventform .el-date-editor {
  width: 96rem;
}
.finisheventform .EventSummary {
  .el-select {
    width: 20rem;
  }
  .AfterparticipaterUsers {
    .el-select {
      width: 96rem;
      .el-input {
        width: 96rem;
      }
    }
  }
}

.finisheventform .el-input__count {
   background:#074E85B3 !important;
}
</style>